import { Lock, HeartHandshake, Sparkles } from "lucide-react";
import PublicNav from "@/components/PublicNav";
import Footer from "@/components/Footer";

export default function About() {
  return (
    <div>
      <PublicNav />
      <section className="dk-container py-16 max-w-3xl">
        <span className="badge-soft mb-3">About</span>
        <h1 className="text-[32px] sm:text-[40px] font-semibold">A gentle guide, on your side</h1>
        <p className="mt-4 text-[18px]" style={{ color: "var(--text-muted)" }}>
          Parents misread what kids say and do — not because they don't care, but because the language changes every month. DecodeKid was built to close that gap with warmth, never judgement.
        </p>

        <div className="dk-card p-8 mt-8 space-y-5">
          <div className="flex gap-4">
            <span className="grid place-items-center w-11 h-11 rounded-xl shrink-0" style={{ background: "var(--sage-tint)" }}><Sparkles style={{ color: "var(--sage)" }} /></span>
            <div><h3 className="font-serif text-[20px] font-medium">How we use AI</h3><p className="text-sm mt-1" style={{ color: "var(--text-muted)" }}>Your text is sent securely to a trusted AI provider only to produce an answer, under an agreement that forbids training on your data or human review. Answers are AI-generated and always framed as guidance.</p></div>
          </div>
          <div className="flex gap-4">
            <span className="grid place-items-center w-11 h-11 rounded-xl shrink-0" style={{ background: "var(--sage-tint)" }}><Lock style={{ color: "var(--sage)" }} /></span>
            <div><h3 className="font-serif text-[20px] font-medium">How we protect your family</h3><p className="text-sm mt-1" style={{ color: "var(--text-muted)" }}>Child profiles hold only an age band, an optional nickname and a style tag — encrypted with a key unique to your account. We ask you to avoid identifying details, and mask phone numbers and emails automatically.</p></div>
          </div>
          <div className="flex gap-4">
            <span className="grid place-items-center w-11 h-11 rounded-xl shrink-0" style={{ background: "var(--sage-tint)" }}><HeartHandshake style={{ color: "var(--sage)" }} /></span>
            <div><h3 className="font-serif text-[20px] font-medium">What we're not</h3><p className="text-sm mt-1" style={{ color: "var(--text-muted)" }}>Not therapy, not medical advice, not a monitoring tool. When something serious appears, we step back and point to real help.</p></div>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
}
